"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_1 = require("../any/is-missing");
/*
 * Checks if string is null or empty
 *
 * @Param {string} str = The string to check.
 *
 * @Example
 *
 *   isMissingOrEmpty('')
 *   //=> true
 *
 *   isMissingOrEmpty(null)
 *   //=> true
 *
 *   isMissingOrEmpty(undefined)
 *   //=> true
 *
 *   isMissingOrEmpty('banana')
 *   //=> false
 */
function isMissingOrEmpty(str) {
    return is_missing_1.isMissing(str) || str.length < 1;
}
exports.isMissingOrEmpty = isMissingOrEmpty;
//# sourceMappingURL=is-missing-or-empty.js.map